// Components
import Router from './Router';

export default Router;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Root/Root.tsx